import React from 'react';
import { Link } from 'react-router-dom';
import './Hero.css';

const Hero = ({ title, subtitle, backgroundImage, eyebrow, showCta = false, ctaText, ctaLink, overlay = true }) => {
  return (
    <section
      className="hero"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      {overlay && <div className="hero__overlay" />}
      <div className="hero__content container">
        {eyebrow && <p className="hero__eyebrow">{eyebrow}</p>}
        <h1 className="hero__title">{title}</h1>
        {subtitle && <p className="hero__subtitle">{subtitle}</p>}
        {showCta && (
          <Link to={ctaLink} className="btn btn-primary hero__cta">
            {ctaText}
          </Link>
        )}
      </div>
    </section>
  );
};

export default Hero;
